// extracted by mini-css-extract-plugin
export default {"main-content-wrapper":"Network_main-content-wrapper__uKeUc","main":"Network_main__sdDhn","top-section":"Network_top-section__3Dq+9","bottom-section":"Network_bottom-section__FdyM-"};